/*
 * AppVerifyStepTwo Enums
 *
 * Update this file (and remove this line), or delete the file if not needed.
 *
 * Reminder:
 * enum name should use TitleCase and end with 'Enum'
 * enum keys should use TitleCase
 *
 */

export enum DatesDropdownEnum {
  Today = "Today",
  LastWeek = "Last week",
  ThisMonth = "This month",
  CustomDateRange = "Custom date range...",
}

export enum StatusTypeEnum {
  INITIAL = "INITIAL",
  PROCESSING = "PROCESSING",
  ERROR = "ERROR",
}

export enum AppTypeEnum {
  APP = "app",
}
